import React from "react";
import PropTypes from "prop-types";
var StepQuestion = function StepQuestion(_ref) {
  var content = _ref.content,
    stepsNumber = _ref.stepsNumber;
  return /*#__PURE__*/React.createElement("div", {
    className: "step__question-container"
  }, /*#__PURE__*/React.createElement("p", {
    className: "step__title",
    dangerouslySetInnerHTML: {
      __html: "".concat(content.Heading, "/").concat(stepsNumber - 1)
    }
  }), /*#__PURE__*/React.createElement("h2", {
    className: "step__question",
    dangerouslySetInnerHTML: {
      __html: content.Heading2
    }
  }));
};
export default StepQuestion;
StepQuestion.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  content: PropTypes.object.isRequired,
  stepsNumber: PropTypes.number.isRequired
};